<template>
    <div v-if="categories && categories.length">
        <div>
            <h4 class="mt-0 filter-subtitle">Categorias</h4>
            <hr class="sidebar-categories-spacer">
            <div class="form-check mb-3" v-for="item in list_categories" :key="item.id">
                <input class="form-check-input" type="checkbox" :value="item.code" :id="'filter_category' + item.code" v-model="filter_categories" @change="change_filter_category($event)">
                <label class="form-check-label filter-option-name" :for="'filter_category' + item.code">
                    {{ item.name }}
                </label>
            </div>
            <hr class="sidebar-categories-spacer mt-4">
        </div>
    </div>
</template>

<script>
import utils from '~/mixins/utils.js';
import ecommerce_products_filters from "~/mixins/ecommerce_products_filters";

export default {
    props: [
        'categories'
    ],
    mixins: [
        utils,
        ecommerce_products_filters
    ]
}
</script>
